/**
 * This is a list of errors that will not be displayed by the ErrorSnackbar component
 */
export const errorBlacklist = [
  'update password',
];
